const T_PREFIX = "auth";

export const passwordUpdatedPopupTrns = {
  title: `${T_PREFIX}.password-updated-popup.title`,
  description: `${T_PREFIX}.password-updated-popup.description`,
  gotItButton: `${T_PREFIX}.password-updated-popup.got-it-btn`,
};
